export const SET_IS_REQUIRED_MODULE = 'SET_IS_REQUIRED_MODULE';

export const SetIsRequiredModule = (value) => {
    return {
        type: SET_IS_REQUIRED_MODULE,
        payload: {
            value: value
        }
    }
}